<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.mt10 {
  margin-top: 10px;
}
.my-credits {
  background-color: #f1f0f0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .loading {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%, 50%);
  }
  .creditsTop {
    display: flex;
    width: 100%;
    .creditsNum {
      width: 100%;
      height: 250px;
      cursor: pointer;
      background: url("../../assets/imgs/teacherRoadImg/31.png") no-repeat
        center center;
      background-size: 100% 100%;
      // background-image: linear-gradient(146deg, #ffdcaa 0%, #e2ab65 100%);
      // box-shadow: 0px 2px 20px 0px #e1d9c2;
      border-radius: 12px;
      .qianDao {
        display: flex;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        float: left;
        margin-left: 300px;
        margin-top: 40px;
        // margin: 35px 0px 0px 80px;
        background-image: linear-gradient(133deg, #facf90 0%, @primary-color 100%);
        box-shadow: inset 3px 3px 14px 0px rgba(255, 255, 255, 0.9),
          inset -3px -3px 14px 0px #dd9438;
        z-index: 9;
        .qdText {
          align-self: center;
          margin: auto;
          text-align: center;
          .qd {
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 0px;
            color: #ffffff;
            margin-left: 6px;
          }
          .add1 {
            font-size: 32px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 0px;
            color: #ffffff;
          }
        }
      }
      .totalPoint {
        width: 180px;
        height: 60px;
        float: left;
        margin: 70px 0 0 100px;
        // margin: 0 auto;
        .pointText {
          display: inline-block;
          height: 60px;
          font-size: 32px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 60px;
          color: #ffffff;
        }
        .pointNum {
          height: 60px;
          display: inline-block;
          font-size: 80px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 60px;
          margin-left: 30px;
          color: #ffffff;
        }
      }
    }
  }
  .creditsday {
    width: 100%;
    height: 200px;
    background-color: #fff;
    // margin-left: 20px;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 0px;
    border-radius: 12px;
    .signInText {
      text-align: center;
      margin-top: 20px;
      margin-left: 20px;
      height: 34px;
      line-height: 34px;
      letter-spacing: 0px;
      color: #040506;
      font-size: 20px;
    }
    .signInMes {
      margin-top: 20px;
      ul {
        list-style: none;
        display: flex;
        width: 100%;
        padding: 0 20px;
        li {
          list-style: none;
          width: 14.285%;
          text-align: center;
          .signDate {
            height: 34px;
            line-height: 34px;
          }
          .twoPoint {
            display: inline-block;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #f1f0f0;
            color: #bdb6b4;
            font-size: 20px;
            border-radius: 50%;
            margin-top: 10px;
          }
          .signImg {
            width: 44px;
            height: 44px;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }
  }
  .creditsBottom {
    width: 100%;
    height: 330px;
    background-color: #fff;
    margin-top: 20px;
    border-radius: 12px;
    cursor: pointer;
    .dailyTitle {
      width: 96px;
      height: 55px;
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 55px;
      letter-spacing: 0px;
      color: #040506;
      margin-left: 50px;
    }
    .dailyTask {
      margin-top: 30px;
      width: 90%;
      margin: auto;
      .achiveTask,
      .askQues,
      .thinkActive,
      .daliyRead {
        position: relative;
        .achive {
          position: absolute;
          bottom: 10px;
          left: 30%;
        }
      }
      ul {
        display: flex;
        li {
          flex: 1;
          list-style: none;
          .taskImg {
            width: 180px;
            height: 200px;
            display: block;
          }
          .taskText {
            width: 180px;
            margin-top: 15px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            color: #040506;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
          }
          .taskNum {
            width: 180px;
            height: 34px;
            line-height: 34px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="my-credits">
    <a-spin class="loading"
            v-show="loading" />
    <div class="creditsTop">
      <div class="creditsNum">

        <div class="totalPoint"
             ref="totalPoint">
          <span class="pointText">总积分</span>
          <span class="pointNum">{{pointNum}}</span>
        </div>
        <div class="qianDao"
             @click="signIn"
             v-if="showSignIn">
          <div class="qdText">
            <span class="qd">签到</span> <br />
            <span class="add1">+1</span>
          </div>
        </div>
      </div>

    </div>
    <div class="creditsday">
      <div class="signInText">已签到{{dayNum}}天</div>
      <div class="signInMes">
        <ul>
          <li v-for='(item, index) in signDaily'
              :key='index'>
            <div class="signDate">{{format.formatDay(item.createDate)}}</div>
            <span class="twoPoint"
                  v-if="item.isIn==2">+2</span>
            <delete-icon v-if="item.isIn==1"
                         class="mt10"
                         type="achiveIcon" />
            <delete-icon v-if="item.isIn==0"
                         class="mt10"
                         type="unachiveIcon" />
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="creditsBottom"> -->
    <!-- <div class="dailyTitle">
        每日任务
      </div>
      <div class="dailyTask">
        <ul>
          <li>
            <div class="daliyRead"
                 @click="goBook">
              <img class="taskImg"
                   src="../../assets/imgs/36.png"
                   alt="">
              <div class="achive">
                <span style="color:#ff914a">去完成</span>
                <delete-icon style="padding-top:18px;"
                             type="achivePink" />
              </div>
            </div>
            <div class="taskText">每日阅读</div> -->
    <!-- <div class="taskNum">+1</div> -->
    <!-- </li> -->
    <!-- <li>
            <div class="thinkActive"
                 @click="goBook">
              <img class="taskImg"
                   src="../../assets/imgs/37.png"
                   alt="">
              <div class="achive">
                <span style="color:#06bc8c">去完成</span>
                <delete-icon style="padding-top:18px;"
                             type="achivePink" />
              </div>
            </div>
            <div class="taskText"
                 @click="goBook">想法互动</div> -->
    <!-- <div class="taskNum">+2</div> -->
    <!-- </li> -->
    <!-- <li>
            <div class="askQues">
              <img class="taskImg"
                   src="../../assets/imgs/38.png"
                   alt="">
              <div class="achive">
                <span style="color:#ff914a">去完成</span>
                <delete-icon style="padding-top:18px;"
                             type="achivePink" />
              </div>
            </div>
            <div class="taskText">提问回答</div> -->
    <!-- <div class="taskNum">+2</div> -->
    <!-- </li> -->
    <!-- <li>
            <div class="achiveTask">
              <img class="taskImg"
                   src="../../assets/imgs/39.png"
                   alt="">
              <div class="achive">
                <span style="color:#06bc8c">去完成</span>
                <delete-icon style="padding-top:18px;"
                             type="achivePink" />
              </div>
            </div> -->
    <!-- <div class="taskText">完成任务</div> -->
    <!-- <div class="taskNum">+3</div> -->
    <!-- </li> -->
    <!-- </ul> -->
    <!-- </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import deleteIcon from 'components/Icon.vue'
import format from 'utils/format.js'
export default {
  name: 'MyCredits',
  components: {
    deleteIcon
  },
  data () {
    return {
      loading: false,
      showSignIn: true, // 签到展示
      format,
      dataInfo: {},
      pointNum: '', // 积分数
      dayNum: '', // 累计签到天数
      signDaily: [], // 签到数据展示
      newDay: [],
      newDateTime: ''
    }
  },
  methods: {
    getPointInfo () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/personal/getSignInInfo'
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res.resultCode === 0 && res.success) {
          this.pointNum = res.resultData.score
          this.dayNum = res.resultData.totalDays
          this.signDaily = res.resultData.records.reverse() // 86400000一天的时间戳
          this.newDateTime = res.resultData.records[2].createDate // 获取今天的时间 在今天的时间后面添加四天时间
          if (res.resultData.records[2].isIn == 1) {
            this.showSignIn = false
            this.$refs.totalPoint.style.marginTop = '60px'
          }
          for (let i = 0; i < 4; i++) {
            this.newDateTime = this.newDateTime + 86400000
            this.signDaily.push({
              createDate: this.newDateTime,
              isIn: 2,
              userId: ''
            })
          }
        }
      }
      )
    },
    signIn () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/personal/signIn'
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(
        res => {
          if (res.success && res.resultCode === 0) {
            this.$message.success('签到成功')
            this.showSignIn = false
            this.$refs.totalPoint.style.marginTop = '60px'
            this.getPointInfo()
          }
        }
      )
    },
    goBook () {
      this.$router.push({ path: '/books' })
    }
  },
  mounted () {
    this.getPointInfo()
  }
}
</script>
